$(() => {
  const key = 'show-if-checked-any';
  $(`[data-${key}]`).on('change', function () {
    const targetSelector = $(this).data(key);

    if ($(`[data-${key}="${targetSelector}"]:checked`).length) {
      $(targetSelector).removeClass('d-none');
    } else {
      $(targetSelector).addClass('d-none');
    }
  });
});
